// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__228ps","rootSmall":"AddTileButton_rootSmall__3Ecxx"};